





































import { Component, Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';

import { Checkbox } from '@/components/forms';
import { MapStore } from '@/store/map';
import { environnementLimits } from '@/config';
import { WidgetGeneric } from './WidgetGeneric';
import { MarkerTemplateParams, WidgetConfig } from '@/models/widget-config.model';

@Component({
  components: { Checkbox }
})
export default class WidgetEnvironment extends WidgetGeneric {
  @Prop({ required: true, default: [] }) readonly checkboxes!: Record<string, any>[];
  @Prop({ required: true }) readonly closeOpenSubCategories!: () => void;
  @Prop({ required: true }) readonly unselectCategory!: (category: string, type: string) => void;

  created(): void {
    this._mapStore = getModule(MapStore, this.$store);
    this._points = new Map();
    this._widgetType = 'ENVIRONMENT';
    this._config = this._createConfig();
  }

  beforeDestroy(): void {
    this.checkboxes.forEach((checkbox: any) => {
      checkbox.selected = false;
      if (checkbox.open) checkbox.open = false;
      if (checkbox.subCat) {
        checkbox.subCat.forEach((el: any) => {
          el.selected = false;
        });
      }
    });
    this._beforeDestroy();
    this._mapStore.setGreenSpacesModal(false);
    this._mapStore.setAirQualityModal(false);
    this._mapStore.setNoiseLevelLegend(false);
    this._mapStore.removeLayer({ type: 'noise-level' });
    this._mapStore.removeSource({ type: 'noise-level' });
  }

  disableOtherWidgets(type: string): void {
    if (type === 'green-spaces-environment') {
      this._mapStore.setAirQualityModal(false);
      this.unselectCategory('environnement', 'air-quality');
    }
    if (type === 'air-quality') {
      this._mapStore.setGreenSpacesModal(false);
      this.unselectCategory('environnement', 'green-spaces-environment');
    }
    if (this._mapStore.recruitmentPoolWidget) {
      this._mapStore.removeLayer({ type: 'ECONOMIC_ECOSYSTEM_MULTIPOLYGON' });
      this._mapStore.removeSource({ type: 'ECONOMIC_ECOSYSTEM_MULTIPOLYGON' });
      this._mapStore.setRecruitmentPoolWidget(false);
      this.unselectCategory('economicEcosystem', 'RECRUITMENT_POOL');
    }
    if (this._mapStore.selectedPopupEmploi) {
      this._mapStore.removeLayer({ type: 'JOBS' });
      this._mapStore.removeSource({ type: 'JOBS' });
      this._removeEmploiPopup();
      this.unselectCategory('economicEcosystem', 'JOBS');
      this._mapStore.setSelectedPopupEmploi(null);
    }
  }

  change({ type, value }: { type: string; value: boolean }) {
    if (type === 'air-quality') {
      this._mapStore.setAirQualityModal(value);
      this.disableOtherWidgets(type);
    }
    if (type === 'green-spaces-environment') {
      this._mapStore.setGreenSpacesModal(value);
      this.disableOtherWidgets(type);
    }
    if (type === 'noise-level') {
      if (value) {
        this._addNoiseLevelIsohrone(type);
      } else {
        this._mapStore.removeLayer({ type });
        this._mapStore.removeSource({ type });
      }
      this._mapStore.setNoiseLevelLegend(value);
    }
  }

  private _createConfig(): WidgetConfig {
    const config: any = {};
    this.checkboxes.forEach((checkbox: Record<string, any>) => {
      config[checkbox.type] = { marker: WidgetEnvironment._markerTemplate, tableName: checkbox.type };
      if (checkbox.subCat) {
        config[checkbox.type].tableNames = checkbox.subCat.map((el: any) => {
          config[el.type] = { marker: WidgetEnvironment._markerTemplate };
          return el.type;
        });
      }
    });
    return config;
  }

  private static _markerTemplate({ name }: MarkerTemplateParams): HTMLDivElement {
    const markerElement = document.createElement('div');
    markerElement.className = 'environment__marker';

    if (name) {
      markerElement.innerText = name;
      markerElement.style.color = WidgetEnvironment._getColorLimit(name);
    }

    return markerElement;
  }

  private static _getColorLimit(name: string): string {
    const [, value, key] = name.match(/([\d ]*)(.+)/) || ['', '0', 'default'];

    const valueNumber = Number(value.replace(/\D/g, ''));

    const { min, max } = environnementLimits[key.toLowerCase()] || environnementLimits.default;
    const range = valueNumber < min ? Number(min) : valueNumber > max ? Number(max) : valueNumber;

    const percent = ((range - min) * 100) / (max - min);

    const red = ((255 - 64) * (100 - percent)) / 100 + 64;
    const green = ((205 - 108) * percent) / 100 + 108;
    const blue = (109 * percent) / 100;

    return `rgb(${red} ${green} ${blue})`;
  }
}
